import { axiosInstanceTasks } from "../axios";
import { Historys, RequestResponse } from "../types";

export const getAllHistory = async (
  pageNumber: number,
  pageSize: number,
  status?: string,
  dateFrom?: string,
  dateTo?: string,
  dateFilterColumn?: string,
  taskClassName?: string
): Promise<RequestResponse<{ records: Historys[]; total: number }>> => {
  try {
    let url = `/task-histories-paginated?`;

    const params = new URLSearchParams();
    params.append("page", pageNumber.toString());
    params.append("size", pageSize.toString());

    if (status) {
      params.append("status", status);
    }
    if (dateFrom) {
      params.append("dateFrom", dateFrom);
    }
    if (dateTo) {
      params.append("dateTo", dateTo);
    }
    if (dateFilterColumn) {
      params.append("dateFilterColumn", dateFilterColumn);
    }
    if (taskClassName) {
      params.append("taskClassName", taskClassName);
    }
    url += params.toString();

    const response = await axiosInstanceTasks.get(url);
    return {
      error: false,
      data: {
        records: response.data.data.records,
        total: response.data.data.total,
      },
    };
  } catch (err) {
    console.error("Unable to fetch history: ", err);
    return {
      error: true,
      message: err.response?.data?.error_description?.includes(
        "Access is denied"
      )
        ? "Access denied: You do not have permission to perform this activity."
        : err.response?.data?.error_description ||
          err.response?.data?.message ||
          err.message ||
          err,
      data: null,
    };
  }
};
